import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCurrentModDetails } from 'store/redux-store/placement-mods/selectors';
import { preferencesModStyles } from './PreferencesMod.styles';

export const HousingInfo = () => {
  // Get API data from redux store
  const selectedModsDetails = useSelector(selectCurrentModDetails);

  // Get styles
  const { classes } = preferencesModStyles();

  // Get translation data
  const { t } = useTranslation();

  return (
    <>
      <Box className={classes.containerItem}>
        <Typography component="span" className={classes.heading}>
          {t('placement.placementMods.housingInfo')}
        </Typography>
      </Box>
      <Box className={classes.containerItem}>
        <Typography component="span" className={classes.label}>
          {t('placement.placementMods.housingType')}
        </Typography>
        <Typography component="span" className={classes.value}>
          {selectedModsDetails?.housingInfo.housingType || '--'}
        </Typography>
      </Box>
      <Box className={classes.containerItem}>
        <Typography component="span" className={classes.label}>
          {t('placement.placementMods.furnitureExtras')}
        </Typography>
        <Typography component="span" className={classes.value}>
          {selectedModsDetails?.housingInfo.furnitureExtras || '--'}
        </Typography>
      </Box>
      <Box className={classes.containerItem}>
        <Typography component="span" className={classes.label}>
          {t('placement.placementMods.typeOfBed')}
        </Typography>
        <Typography component="span" className={classes.value}>
          {selectedModsDetails?.housingInfo.typeOfBed || '--'}
        </Typography>
      </Box>
    </>
  );
};
